import React from 'react';
import { Link } from "react-router-dom";



class SelectForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            //addr: '',
            left: {
                tabName: "",
                qTitle: "",
                btnName: "",
                storeList: []
            },
            right: {
                tabName: "",
                qTitle: "",
                btnName: "",
                tip: "",
                qList: [],
                itemList: []
            }
        }
        this.storeNameChange = this.storeNameChange.bind(this);
        this.addressChange = this.addressChange.bind(this);
        this.blurHandler = this.blurHandler.bind(this);
        //this.countChange = this.countChange.bind(this);
        this.handleDeliverClick = this.handleDeliverClick.bind(this);
        this.handleOrderClick = this.handleOrderClick.bind(this);
    }

    componentDidMount() {
        // console.log("order form")
        // console.log(this.props.context)
        if (this.props.context !== undefined && this.props.context !== "") {
            if (this.props.context.order !== undefined && this.props.context.order !== "") {
                let left = {
                    tabName: "",
                    qTitle: "",
                    btnName: "",
                    storeList: []
                };
                let right = {
                    tabName: "",
                    qTitle: "",
                    btnName: "",
                    tip: "",
                    qList: [],
                    itemList: []
                }

                if (this.props.context.order.section1 !== undefined) {
                    if (this.props.context.order.section1.tabName !== undefined) {
                        left.tabName = this.props.context.order.section1.tabName;
                    }
                    if (this.props.context.order.section1.qTitle !== undefined) {
                        left.qTitle = this.props.context.order.section1.qTitle;
                    }
                    if (this.props.context.order.section1.storeList !== undefined && this.props.context.order.section1.storeList.length) {
                        left.storeList = this.props.context.order.section1.storeList;
                    }
                    if (this.props.context.order.section1.btnName !== undefined) {
                        left.btnName = this.props.context.order.section1.btnName;
                    }
                }

                if (this.props.context.order.section3 !== undefined) {
                    if (this.props.context.order.section3.tabName !== undefined) {
                        right.tabName = this.props.context.order.section3.tabName;
                    }
                    if (this.props.context.order.section3.qTitle !== undefined) {
                        right.qTitle = this.props.context.order.section3.qTitle;
                    }
                    if (this.props.context.order.section3.item_tip !== undefined) {
                        right.tip = this.props.context.order.section3.item_tip;
                    }
                    if (this.props.context.order.section3.btnName !== undefined) {
                        right.btnName = this.props.context.order.section3.btnName;
                    }
                    if (this.props.context.order.section3.qList !== undefined && this.props.context.order.section3.qList.length) {
                        right.qList = this.props.context.order.section3.qList;
                    }
                    if (this.props.context.order.section3.itemList !== undefined && this.props.context.order.section3.itemList.length) {
                        right.itemList = this.props.context.order.section3.itemList;
                    }
                }

                // console.log(right)

                this.setState({
                    left: left,
                    right: right
                })
            }
        }
    }

    storeNameChange(event) {
        //console.log("storeNameChange: " + event.target.value)
        this.props.changeName(event.target.value)
    }

    //countChange(event) {
    //console.log(event.target.value)
    //this.props.setCount(event.target.value)
    //}


    addressChange(event) {
        //this.setState({ addr: event.target.value })
        this.props.changeAddress(event.target.value)
    }

    blurHandler(event) {
        //this.props.calculate()
    }

    handleDeliverClick() {
        this.props.orderClick("deliver")
    }


    handleOrderClick() {
        this.props.orderClick("takeout")
    }




    render() {

        let left_items;
        let __self = this;
        if (this.state.left.storeList !== undefined && this.state.left.storeList.length) {
            left_items = this.state.left.storeList.map((store, i) => {
                if (store.qList !== undefined && store.qList.length) {
                    let li = store.qList.map((item, j) => {
                        if (item.sName !== undefined && item.storeAddr !== undefined) {
                            let tags = item.sName;
                            if (item.storeAddr !== "") {
                                tags += "/" + item.storeAddr;
                                // <span><img src="/static/images/img_map_1.png" /></span>
                            }
                            return (
                                <li className="pickup_store_content" key={j}>
                                    <input type="radio" name="store_name" value={item.sName} onChange={__self.storeNameChange} />
                                    {tags}

                                </li>
                            )
                        }
                    })

                    return (
                        <div key={i}>
                            <div className="pickup_store_title">{store.item_name}</div>
                            <ul>
                                {li}
                            </ul>
                        </div>
                    )
                }
            })
        }


        let right_tips;
        if (this.state.right.qList !== undefined && this.state.right.qList.length) {
            right_tips = this.state.right.qList.map((item, i) => {
                if (item.linkUrl !== undefined && item.linkUrl !== "" && item.linkTitle !== undefined && item.linkTitle !== "") {
                    return (
                        <li className="deliver_add_tip" key={i}>{item.item_tip} <Link to={item.linkUrl}>{item.linkTitle}</Link></li>
                    )
                } else {
                    return (<li className="deliver_add_tip" key={i}>{item.item_tip}</li>)
                }
            })
        }

        let right_list;
        if (this.state.right.itemList !== undefined && this.state.right.itemList.length) {
            right_list = this.state.right.itemList.map((item, i) => {
                let li;
                if (item.qList && item.qList.length) {
                    li = item.qList.map((q, j) => {
                        if (q.item_content !== undefined && q.item_content !== "") {
                            return (<li className="deliver_add_content" key={j}>{q.item_content}</li>)
                        }
                    })
                }

                return (
                    <div key={i}>
                        <div className="deliver_add_title" >{item.qname}</div>
                        <ul>
                            {li}
                        </ul>
                    </div>
                )
            })
        }


        let li_style = {}
        let nav_item_right = (<li className="nav-item">
            <a className="nav-link" href="#p-view-2" role="tab" data-toggle="tab">
                <i className="fas fa-truck"></i>{this.state.right.tabName}
            </a>
        </li>)

        if (window.location && window.location.href.indexOf("destination=1") !== -1) {
            nav_item_right = undefined
            li_style.width = '100%'
        }




        return (
            <div className="step1-frame">
                <section className="main_banner_wrap order_pickup order_pickup_bg" style={{ background: 'url(/static/images/img_food_1.jpg) center center no-repeat' }}>
                    <div>
                        <div>
                            <div className="col-md-6 col-sm-6 col-xs-12 order_pickup_wrap">
                                <div className="tab-menu">
                                    <ul className="nav nav-tabs" role="tablist">
                                        <li className="nav-item" style={li_style}>
                                            <a className="nav-link active" href="#p-view-1" role="tab" data-toggle="tab">
                                                <i className="fas fa-store"></i>{this.state.left.tabName}
                                            </a>
                                        </li>
                                        {nav_item_right}
                                    </ul>
                                </div>
                                <div className="tab-content">
                                    <div className="tab-pane active" id="p-view-1">
                                        <div className="tab-inner">
                                            <div className="order_pickup_store_wrap">
                                                <div className="pickup_store_main_title">{this.state.left.qTitle}</div>
                                                {left_items}
                                                <div className="pickup_store_start" onClick={this.handleOrderClick}>{this.state.left.btnName}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-pane" id="p-view-2">
                                        <div className="tab-inner">
                                            <div className="order_deliver_add_wrap">
                                                <div className="deliver_add_main_title">{this.state.right.qTitle}</div>
                                                <div>
                                                    <input className="deliver_add_input" placeholder={this.state.right.tip} type="text" name="" value={this.props._addr} onChange={this.addressChange} onBlur={this.blurHandler} />
                                                    <ul>
                                                        {right_tips}
                                                    </ul>
                                                </div>
                                                {right_list}
                                                <div className="pickup_store_start" onClick={this.handleDeliverClick}>{this.state.right.btnName}</div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            </div>
        )
    }
}



class IframeMenu extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        console.log(this.props)
    }

    render() {
        return (
            <div className="step2-frame">
                <iframe src={this.props.src} height={this.props.height} width={this.props.width} className="fullheight" />
            </div>
        )
    }
}






class OrderForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            address: '',
            q_address: '',
            store_name: '',
            type: "",
            step: 1,
            mask: false,
            mask_text: "",
            item: {},
            latLng: null,
            store: []
            //     { addr: '台北市大安區永康街10巷7號', name: '永康店', distance: { text: "", value: 0 } },
            //     { addr: '新北市板橋區縣民大道二段7號', name: '板橋店', distance: { text: "", value: 0 } },
            //     { addr: '台北市南港區經貿二路166號', name: '南港店', distance: { text: "", value: 0 } },
            //     { addr: '台北市中正區懷寧街17號', name: '站前店', distance: { text: "", value: 0 } },
            // ]

        };

        this.handleAddressChange = this.handleAddressChange.bind(this);
        this.handleStoreNameChange = this.handleStoreNameChange.bind(this);
        this.handleOrderClick = this.handleOrderClick.bind(this);
        this.calculateDistance = this.calculateDistance.bind(this)
        //this.handleCountChange = this.handleCountChange.bind(this)
        // this.handleDeliverClick = this.handleDeliverClick.bind(this);
        //this.handleStepChange = this.handleStepChange.bind(this);
    }

    componentWillMount() {
        console.log(" << orderForm context", this.props.context)
        let store_list = []
        if (this.props.context !== undefined && this.props.context.order !== undefined && this.props.context.order.section1 !== undefined) {
            if (this.props.context.order.section1.storeList !== undefined && this.props.context.order.section1.storeList.length) {
                this.props.context.order.section1.storeList.map((item) => {
                    console.log(item)
                    if (item && item.qList !== undefined && item.qList.length) {
                        item.qList.map((q) => {
                            console.log(q)
                            if (q && q.sName !== undefined && q.sName !== "" && q.storeAddr !== undefined && q.storeAddr !== "") {
                                store_list.push({
                                    addr: q.storeAddr,
                                    name: q.sName,
                                    distance: { text: "", value: 0 }
                                })
                            }
                        })
                    }
                })
            }
        }

        console.log("store_list::::: ", store_list)
        if (store_list.length) {
            this.setState({ store: store_list })
        }
    }

    componentDidMount() {

    }

    handleAddressChange(value) {
        this.setState({ address: value });
    }

    handleStoreNameChange(value) {
        this.setState({ store_name: value });
    }

    // handleCountChange(value) {
    //     this.setState({ count: value });
    // }


    calculateDistance() {

        return new Promise((resolve, reject) => {
            if (!window.directionsMatrixService || window.directionsMatrixService == undefined) {
                //if (!window.directionsService || window.directionsService == undefined) {
                // if (callback !== undefined) {
                //     callback({ result: false })
                // }
                reject({ err: "服務尚未啟用，請洽詢管理者" })
                return;
            }

            if (this.state.address === "") {
                // if (callback !== undefined) {
                //     callback({ result: false })
                // }
                reject({ err: "請先填入外送地址" })
                return;
            }

            let __self = this;
            //const address = this.state.address;
            //this.setState({ q_address: address })

            // let store_conut = this.state.store.length;
            // let response_count = 0;

            let request = {
                origins: [],
                destinations: [this.state.address],
                // origins: [this.state.address],
                // destinations: [],
                travelMode: window.google.maps.TravelMode.DRIVING,
                unitSystem: window.google.maps.UnitSystem.METRIC,
                avoidHighways: false,
                avoidTolls: false,
            }

            this.state.store.map((item) => {
                if (item.addr) {
                    request.origins.push(item.addr)
                    //  request.destinations.push(item.addr)
                }
            })


            window.directionsMatrixService.getDistanceMatrix(request)
                .then((response) => {
                    console.log("get DistanceMatrix: ", response)
                    //__self.setState({ mask: false, mask_text: "" });
                    resolve(response)
                })


            // this.state.store.map((item) => {
            //     window.directionsService.route({
            //         origin: item.addr, //address,
            //         destination: address, //item.addr,
            //         travelMode: 'DRIVING'
            //     }, function (response, status) {
            //         if (status === 'OK') {
            //             console.log(response)
            //             if (response != undefined && response.routes != undefined && response.routes.length) {
            //                 if (response.routes[0].legs != undefined && response.routes[0].legs.length) {
            //                     if (response.routes[0].legs[0].distance != undefined && response.routes[0].legs[0].distance.value != undefined) {
            //                         item.distance = response.routes[0].legs[0].distance;
            //                         if (__self.state.item !== undefined && __self.state.item.addr === undefined) {
            //                             __self.setState({ item: item })
            //                         } else {
            //                             if (item.distance != undefined && item.distance.value != undefined) {
            //                                 if (item.distance.value < __self.state.item.distance.value) {
            //                                     __self.setState({ item: item })
            //                                 }
            //                             }
            //                         }
            //                     }
            //                 }
            //             }
            //             response_count++;
            //             console.log("response_count: " + response_count)
            //             if (response_count >= store_conut) {
            //                 __self.setState({ mask: false, mask_text: "" });
            //                 if (callback !== undefined) {
            //                     callback({ result: true })
            //                 }
            //             }
            //         } else {
            //             console.info('Directions request failed due to ' + status);
            //             if (callback !== undefined) {
            //                 callback({ result: false })
            //             }
            //         }

            //     })
            // })


        })

    }


    handleOrderClick(type) {
        console.log("type: " + type)
        if (type !== undefined && type !== "") {
            switch (type) {

                case "deliver":
                    if (this.state.address === "") {
                        alert("請先填入您要外送的地址")
                        return;
                    }



                    let __self = this;

                    //console.log("地址不相同")
                    const address = this.state.address;
                    this.setState({ mask: true, mask_text: "", q_address: address, latLng: null });
                    // let __this = this;
                    // this.checkAddress(this.state.address)
                    //     .then(() => {
                    //         __this.calculateDistance(callback)
                    //     })
                    //     .catch(() => {
                    //         __this.calculateDistance(callback)
                    //     })
                    this.calculateDistance()
                        .then((response) => {
                            __self.setState({ mask: false, mask_text: "" });



                            if (response && response.destinationAddresses && response.destinationAddresses.length) {
                                if (response.destinationAddresses[0] === "") {
                                    alert("地址有誤，請輸入正確地址！")
                                    return null
                                }
                            }
                            __self.setState({ address: response.destinationAddresses[0] });

                            if (response && response.rows && response.rows.length) {
                                let target;
                                let distance;
                                let key;
                                let tmp;
                                if (response.rows[0] && response.rows[0].elements && response.rows[0].elements.length) {
                                    response.rows[0].elements.map((item, index) => {
                                        if (!distance) {
                                            distance = item.distance.value;
                                            key = index;
                                            tmp = item.distance;
                                        } else if (item.distance.value < distance) {
                                            distance = item.distance.value;
                                            key = index;
                                            tmp = item.distance;
                                        }
                                    })

                                    //console.log("distance, key", { distance, key })
                                    if (__self.state.store[key]) {
                                        target = __self.state.store[key];
                                    }
                                    // if (response.destinationAddresses && response.destinationAddresses[key]) {
                                    //     __self.state.store.map((item) => {
                                    //         if (item.addr === response.destinationAddresses[key]) {
                                    //             target = item;
                                    //         }
                                    //     })
                                    // }
                                }

                                //console.log("target:", target)
                                if (target && target.addr) {
                                    target = JSON.parse(JSON.stringify(target))
                                    target.distance = tmp;
                                    console.log("target:", target)
                                    __self.setState({ item: target });
                                }

                                if (target && window.confirm(`請再次確認您輸入的地址是否正確？ ${response.destinationAddresses[0]}`)) {
                                    //__self.setState({ step: 2, type: "deliver", mask: true, mask_text: "請稍候..." });
                                    __self.setState({ type: "deliver", mask: true, mask_text: "請稍候..." });
                                }

                                return window.geocoder.geocode({ address: response.destinationAddresses[0] })
                            }
                        })
                        .then((response) => {
                            if (!address) {
                                __self.setState({ type: "", mask: false, mask_text: "" });
                                return
                            }

                            // 取得地址經緯度

                            console.log("response: ", response);
                            let latLng;
                            if (response && response.results.length) {
                                let itemData = response.results[0];
                                if (itemData && itemData.geometry && itemData.geometry.location) {
                                    latLng = {
                                        lat: itemData.geometry.location.lat(),
                                        lng: itemData.geometry.location.lng(),
                                    }

                                    console.log("latLng: ", latLng);
                                }
                            }

                            if (!latLng) {
                                __self.setState({ type: "", mask: false, mask_text: "" });
                                alert("查無地址經緯度資訊，請確認輸入地址是否正確")
                                return
                            }

                            __self.setState({ step: 2, latLng: latLng });
                        

                        })
                        .catch((error) => {
                            __self.setState({ mask: false, mask_text: "" });
                            if (error && error.err) {
                                alert(error.err)
                            } 
                            console.error(error)
                            return
                        })





                    break;

                case "takeout":
                    if (this.state.store_name === "") {
                        alert("請先選擇自取店面")
                        return;
                    }

                    let __item;
                    this.state.store.map((item) => {
                        if (item.name === this.state.store_name) {
                            __item = item;
                        }
                    })
                    this.setState({ step: 2, type: "takeout", item: __item, mask: true, latLng: null });
                    break;
            }

        }
    }




    // checkAddress = (address) => {
    //     return new Promise((resolve, reject) => {
    //         let __geocoder = false;
    //         if (window.geocoder && window.geocoder.geocode) {
    //             __geocoder = true;
    //         }

    //         if (!__geocoder) {
    //             reject()
    //         }

    //         window.geocoder.geocode({ 'address': address }, (results, status) => {
    //             console.log("checkAddress result", { results, status })
    //             let partial_match = 0;
    //             let formatted_address;
    //             if (status == 'OK' && results && results.length) {


    //             }
    //             resolve()
    //         })
    //     })
    // }


    // handleStepChange(step) { 
    //     // 2: 自取, 3: 外送
    //     this.setState({ step: step });
    // }


    getUrlParams = () => {
        let args = {};
        let params = window.location.href.split("?");
        if (params.length !== 0 && params[1] !== undefined) {
            var parameters = params[1].split("&");
            for (var i = 0; i < parameters.length; i++) {
                let p = parameters[i].split("=");
                args[p[0]] = p[1];
            }
        }

        return args
    }



    render() {

        const { store } = this.state;
        //console.log("store >> ", store)

        let component = null;
        let maskClassName = 'o-mask';
        if (this.state.mask) {
            maskClassName += ' mask-active';
        }

        switch (this.state.step) {
            case 2:
                // let __src = "https://eat.tagfans.com/index.html?id=33811&o=7827&viewType=station&bg=null"; //window.location.protocol + "//eat.tagfans.com/index.html?id=33811&o=7827&viewType=station&bg=null";
                // if (window.location.href.indexOf("ricecafe.tagfans.com") !== -1) {
                //     __src = "https://eat.tagfans.com/debug/index.html?id=33811&o=7827&viewType=station&bg=null"; //window.location.protocol + "//eat.tagfans.com/debug/index.html?id=33811&o=7827&viewType=station&bg=null";
                // }

                const list = ["https://service.tagfans.com", "https://eat.tagfans.com/debug"];
                const host = list[1]; //(window.location.href.indexOf("ricecafe.tagfans.com") !== -1) ? list[1] : list[0];

                let __src = `${host}/cloudmenu.html?GID=7827&noteId=4723265&bg=null`


                if (this.state.item !== undefined && this.state.item.name !== undefined) {
                    __src += "&store_name=" + encodeURIComponent(this.state.item.name);
                }


                // if (this.state.item !== undefined && this.state.item.addr !== undefined) {
                //     __src += "&store_addr=" + encodeURIComponent(this.state.item.addr);
                // }

                if (this.state.type !== undefined && this.state.type !== undefined) {
                    __src += "&orderType=" + this.state.type;
                }

                __src += "&kiosk=1&back_url=" + encodeURIComponent(window.location.href);

                let params = this.getUrlParams("destination");
                //console.log("destination: ", params)
                if (params.destination && window.location.href.indexOf("destination=1") !== -1) {
                    __src += "&destination=1&ori=metro"
                } else {
                    __src += "&ori=lalamove"
                }


                let __args = {
                    item: this.state.item,
                    type: this.state.type
                }

                if (this.state.type === "deliver") {
                    //__args.count = this.state.count;
                    __args.address = this.state.address;
                    //__src += "&qs=" + this.state.count;
                    if (this.state.item.distance && this.state.item.distance.value !== undefined) {
                        __src += "&dis=" + encodeURIComponent(btoa(this.state.item.distance.value));
                    }
                    __src += "&address=" + encodeURIComponent(this.state.address);


                    if (this.state.latLng.lat) {
                        __src += `&lat=${this.state.latLng.lat}`
                    }
                    if (this.state.latLng.lng) {
                        __src += `&lng=${this.state.latLng.lng}`
                    }
                }



                console.log("URL: ", __src)
                window.location.href = __src /*+ "#page_join";*/

                break

            default:
                component = <SelectForm _addr={this.state.address} changeName={this.handleStoreNameChange} changeAddress={this.handleAddressChange} orderClick={this.handleOrderClick} calculate={this.calculateDistance} context={(this.props.context !== undefined) ? this.props.context : ""} />
                break;
        }

        return (
            <div className="ordersection-frame">
                {component}
                <div className={maskClassName}><div>{this.state.mask_text}</div></div>
            </div>
        )
    }
}


export default OrderForm


// WEBPACK FOOTER //
// ./src/component/orderForm.js